var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _circle1, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEmptyMovie = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 67,
  height: 41,
  fill: "none"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 2.593,
  cy: 30.91,
  r: 1.708,
  fill: "#FCB115",
  transform: "rotate(-165 2.593 30.91)"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 22.186,
  cy: 32.079,
  r: 2.278,
  fill: "#FCB115",
  transform: "rotate(-165 22.186 32.08)"
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 29.272,
  cy: 33.024,
  r: 2.278,
  fill: "#FCB115",
  transform: "rotate(-165 29.272 33.024)"
})), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
  cx: 14.628,
  cy: 27.355,
  r: 2.278,
  fill: "#FCB115",
  transform: "rotate(-165 14.628 27.355)"
})), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
  cx: 27.159,
  cy: 27.603,
  r: 1.708,
  fill: "#FFE079",
  transform: "rotate(-165 27.16 27.603)"
})), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
  cx: 19.601,
  cy: 20.989,
  r: 1.708,
  fill: "#FFE079",
  transform: "rotate(-165 19.6 20.989)"
})), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
  cx: 6.62,
  cy: 27.378,
  r: 1.139,
  fill: "#FFE079",
  transform: "rotate(-165 6.62 27.378)"
})), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
  cx: 15.124,
  cy: 33.992,
  r: 1.139,
  fill: "#FCB115",
  transform: "rotate(-165 15.124 33.992)"
})), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
  cx: 34.05,
  cy: 30.837,
  r: 1.139,
  fill: "#FCB115",
  transform: "rotate(-165 34.05 30.837)"
})), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
  cx: 22.683,
  cy: 25.015,
  r: 1.139,
  fill: "#FFE079",
  transform: "rotate(-165 22.683 25.015)"
})), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
  cx: 8.038,
  cy: 33.519,
  r: 1.139,
  fill: "#FFE079",
  transform: "rotate(-165 8.038 33.52)"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#F55376",
  d: "M65.951 8.481 37.245.473v.001l-3.795 2.57 2.886 3.673.034.002-1.077 7.686-3.912 3.368 2.836 4.314-1.077 7.69-.033-.007-3.784 2.735 2.942 3.511v.003l29.802.188z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#EB0000",
  d: "m36.425 6.422 26.444 6.179-.904 6.453L35.16 14.47c-.02-.003-.056 0-.056 0l-2.63-4.498 3.687-3.603V6.36l.045.01q.017.001.033.001c.065.01.123.037.185.05m-3.313 23.65 27.123 1.326.904-6.453-27.03-2.96-.053-.015-3.764 3.602z"
})));
export default SvgEmptyMovie;